const ANSWERS_RESULT_CORRECT = 'correct'
const ANSWERS_RESULT_INCORRECT = 'incorrect'
const ANSWERS_RESULT_PARTIAL = 'partial'
const ANSWERS_RESULT_UNANSWERED = 'unanswered'
const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']

const course = {
  LETTERS,
  ANSWERS_RESULT_CORRECT,
  ANSWERS_RESULT_INCORRECT,
  ANSWERS_RESULT_PARTIAL,
  ANSWERS_RESULT_UNANSWERED,
}

export default course
